import { useHarnessStore } from '@/store/useHarnessStore';
import { CurveParametersView } from './CurveParametersView';

/**
 * Live-harness curve-parameters panel: binds {@link CurveParametersView} to the store's active
 * Batch and selection. The review view (Story 3.1) reuses `CurveParametersView` directly with a
 * fetched Batch id and local selection.
 */
export function CurveParametersPanel() {
  const activeBatch = useHarnessStore((s) => s.activeBatch);
  const selectedMeasurementIds = useHarnessStore((s) => s.selectedMeasurementIds);

  return <CurveParametersView batchId={activeBatch?.id ?? null} selectedIds={selectedMeasurementIds} />;
}
